






import config from '../../../config/env';
export default {
  data() {
    return {
      baseUrl: config.baseUrlAlt,
    };
  },
  methods: {
    login() {
      window.location.href = this.baseUrl + '/auth/auth0';
    },
    tL(text: string) {
      return this.$vuetify.lang.t('$vuetify.Login.' + text);
    },
  },
};
